import { observer } from 'mobx-react';
import { FC, ReactElement, useEffect } from 'react';
import { Prompt } from 'react-router-dom';
import GoogleTagManagerTextArea from './components/GoogleTagManagerTextArea/GoogleTagManagerTextArea';
import googleTagManagerStore from './store/googleTagManagerStore';
import { IGoogleTagManager } from './types/googleTagManager';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import SettingControlsBlock from '~/view/screens/SettingsScreen/containers/SettingControlsBlock/SettingControlsBlock';
import ScrollableBlock from '~/view/containers/ScrollableBlock/ScrollableBlock';

const GoogleTagManagerScreen: FC = observer((): ReactElement => {
  useEffect(() => {
    googleTagManagerStore.init();
  }, []);

  const handleFieldChange = (field: keyof IGoogleTagManager) => (value: string | undefined) => {
    googleTagManagerStore.changeTagData({ [field]: value });
  };

  return (
    <div className="d-flex flex-column flex-1">
      <Headers>
        <HeaderBack title={localeStore.t('google_tag_manager')} path={SCREENS.SETTINGS_INTEGRATIONS()} />
      </Headers>

      <ScrollableBlock showScrollbar className="mt-6">
        <div className="d-flex flex-column gap-15 mb-6">
          <GoogleTagManagerTextArea
            value={googleTagManagerStore.tagData.head}
            onChange={handleFieldChange('head')}
            placeholder="<!--Google Tag Manager --> <script></script>"
          />
          <GoogleTagManagerTextArea
            value={googleTagManagerStore.tagData.body}
            onChange={handleFieldChange('body')}
            placeholder="<!--Google Tag Manager (noscript) --> <noscript></noscript>"
          />
        </div>

        <SettingControlsBlock onSubmit={googleTagManagerStore.updateGoogleTagData} />
      </ScrollableBlock>

      <LoadingOverlay visible={googleTagManagerStore.isLoading} refreshing />
      <Prompt when={googleTagManagerStore.isEdit} message={getPromptProps()} />
    </div>
  );
});

export default GoogleTagManagerScreen;
